<template>
  <div>
    <div class="vx-row mb-12">
      <div v-bind:class="[detail ? detailShow+' vertical-divider' : '', detailHide]">
      <div  class="vx-row mb-12">
        <h1>Un-Reconcile Data</h1>
      </div>
        <!-- 
       ADDONs
         
        -->
        <data-table
          :responseData="responseData"
          :propsParams="params"
          :header="header"
          @reloadDataFromChild="reloadData"
          @selectedDataFromChild="selectedRow"
        >
          <template slot="tbody">
            <vs-tr
              :data="tr"
              @click="selectedRow(tr)"
              :key="indextr"
              v-for="(tr, indextr) in responseData.reconcile"
              v-bind:class="[selectedData.ID==tr.ID ? 'colored' : '']"
            >
              <vs-td
                >{{ tr.BankName }} - ({{ tr.BankAccountNumber }} /
                {{ tr.BankAccountOwner }})</vs-td
              >
              <vs-td>{{ dateFormat(tr.CreatedAt) }}</vs-td>
              <vs-td>{{ tr.PaymentCode }}</vs-td>
              <vs-td>{{ tr.PaymentMethod }}</vs-td>
              <vs-td>{{ priceFormat(tr.PaymentAmount) }}</vs-td>
              <vs-td>{{ priceFormat(tr.PaymentCharge) }}</vs-td>
            </vs-tr>
          </template>
        </data-table>
      </div>
      <!-- detail-->
      <transition name="detail-fade">
        <div
          v-if="detail"
          v-bind:class="[detail ? ' nonfixed vx-col md:w-1/2 w-full mb-base' : '', detailHide]"
        >
          <div>
            <vs-col
              style="padding-bottom: 8px"
              vs-offset="8"
              vs-type="flex"
              vs-justify="rigth"
              vs-align="rigth"
              vs-w="4"
            >
              <vs-button
                size="small"
                v-on:click="closeDetail"
                color="grey"
                icon-pack="feather"
                icon="icon-x-square"
              >Close</vs-button>
            </vs-col>
            <payment :selected="selectedData"  :header="params" @reloadDataFromChild="reloadData"></payment>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>


<script>
import payment from "./payment.vue"
import moment from "moment";
export default {
  components: {
    'payment':payment
  },
   props: {
    reload: Boolean,
    selected: Object,
    option: Object,
  },
  watch:{
    reload: function () {
      this.reloadData(true)
    }
  },
  data() {
    return {
      params: {
        search: "",
        length: 10,
        page: 1,
        order: "asc",
        sort: "payment_code"
      },
      header: [
        {
          text: "Bank",
          sortable: false,
          // width: '5%'
        },
        {
          text: "Date Reconcile",
          value: "created_at",
          // width: '5%'
        },
        {
          text: "Code",
          value: "payment_code",
          // width: '5%'
        },
        {
          text: "Method",
          sortable: false,
        },
        {
          text: "Amount",
          sortable: false,
        },
        {
          text: "Charge",
          sortable: false,
        },
      ],
      responseData: {},
      detailShow: "vx-col md:w-1/2 w-full mb-base",
      detailHide: "core vx-col md:w-1/1 w-full mb-base",
      detail: false,
      selectedData: {},
      validateAll: false,
      validate: []
    };
  },
  computed: {},

  mounted() {
    this.reloadData(this.params);

    // this.getData();
    // this.page(1);
    // this.dataId = this.data[0].id
  },
  methods: {
    dateFormat(value) {
      return moment(String(value)).format("DD/MM/YYYY");
    },
    selectedRow(tr) {
      console.log(tr);
      this.detail = true;
      this.selectedData = tr
    },
    
    closeDetail() {
     this.detail = false;
      this.selectedData = {}
    },
    reloadData(params) {
      this.closeDetail()
      this.params = params;
      console.log(params);
      this.$vs.loading();
      this.$http
        .get("api/v1/invoice/list/reconcile", {
          params: {
            search: params.search,
            length: params.length,
            page: params.page,
            order: params.order,
            sort: params.sort,
            status: 2
          }
        })
        .then(resp => {
          if (resp.code == 500) {
            this.$vs.loading.close();
          } else if (resp.code == 200) {
            this.$vs.loading.close();
            this.data = resp.data.reconcile;
            this.responseData = resp.data;
            this.checkedAll = false;
          } else {
            this.$vs.loading.close();
          }
        });
    }
  }
};
</script>
 <style scoped>
.nonfixed {
  position: inherit;
  padding-left: 20px;
}
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transform-origin-y: all 1s ease;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-right: 1px solid #7367f0;
  /* min-height: 800px; */
  /* height: 100%; */
  -webkit-mask-position-y: fixed;
  /* padding: 5px; */
}
.vs-con-table.stripe .tr-values:nth-child(2n) {
  background: beige;
}
.colored {
  border: 1px solid #7367f0;
  position: fixed;
  left: 4%;
  top: 60%;
  max-width: 45%;
  z-index: 999999999999;
  background: antiquewhite;
  background-color: antiquewhite;
}
.colored-detail {
  border: 1px solid #7367f0;
  position: fixed;
  left: 50%;
  top: 60%;
  max-width: 45%;
  z-index: 999999999999;
  background: antiquewhite;
  background-color: antiquewhite;
}
</style>